import { render } from "./C01ItemFormExtraProp.vue?vue&type=template&id=3da1c03a&scoped=true&ts=true"
import script from "./C01ItemFormExtraProp.vue?vue&type=script&lang=ts"
export * from "./C01ItemFormExtraProp.vue?vue&type=script&lang=ts"

import "./C01ItemFormExtraProp.vue?vue&type=style&index=0&id=3da1c03a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da1c03a"]])

export default __exports__